module.exports = __webpack_public_path__ + "static/about1-28fd8c2ac91f8b69662e8cd91835dd70.jpg";